<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="!isFormDisplayed()" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: isFormDisplayed() }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.boxContext.formVisible, 'events-active': context?.boxContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Bannettes"
                createIconText="Ajouter une bannette"
                importDatasourceName="boxes"
                [buttonDisplayListVisible]="isTreeDisplayed()"
                [buttonDisplayTreeVisible]="isListDisplayed()"
                (created)="onBoxCreated()"
                (exported)="onBoxesExported()"
                (imported)="onBoxesImported()"
                (helped)="onBoxesHelped()"
                (listDisplayed)="setDisplayMode(DisplayMode.List)"
                (treeDisplayed)="setDisplayMode(DisplayMode.Tree)"></app-list-header>
        </mat-expansion-panel-header>

        @if (isListDisplayed()) {
            <app-boxes-list
                (itemSelected)="onBoxSelected($event)"
                (itemDisplayed)="onBoxDisplayed($event)"
                (itemEdited)="onBoxEdited($event)"
                (itemDeleted)="onBoxDeleted($event)"
                (itemDuplicated)="onBoxDuplicated($event)"
                (itemsSorted)="onBoxesSorted($event)"></app-boxes-list>
        } @else if (isTreeDisplayed()) {
            <app-boxes-tree
                (itemDisplayed)="onBoxDisplayed($event)"
                (itemEdited)="onBoxEdited($event)"
                (itemDeleted)="onBoxDeleted($event)"
                (itemDuplicated)="onBoxDuplicated($event)"></app-boxes-tree>
        }
    </mat-expansion-panel>

    @if (isFormDisplayed()) {
        <mat-expansion-panel [disabled]="!context?.boxContext.formVisible" [expanded]="isFormDisplayed()" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.boxContext.box.getDisplayName()"
                    [id]="context?.boxContext.box.id"
                    (displayed)="onBoxDisplayed(context?.boxContext.box)"
                    (edited)="onBoxEdited(context?.boxContext.box)"
                    (helped)="onBoxesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-box-detail
                [context]="context"
                (boxUpdated)="onBoxUpdated($event)"
                (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                (canceled)="onBackToList()"></app-box-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
